<picture>
  @for (source of urlData.sources; track source) {
  <source [media]="source.media" [srcset]="source.srcset" />
  }
  <img
    [src]="urlData.src"
    alt=""
    [attr.loading]="loading"
    [width]="sourceWidth"
    [height]="sourceHeight"
    [style.object-position]="position"
    [class.cover]="cover"
  />
</picture>
